import { HONOREE } from "@/lib/eventConfig";

export default function Footer() {
  return (
    <footer
      className="relative py-20 px-6 border-t border-[#E2DFD8] bg-[#FAF9F6]"
      data-testid="footer"
    >
      <div className="max-w-5xl mx-auto text-center">
        <p className="font-serif-display italic text-2xl sm:text-3xl text-[#4A5346]">
          With every blessing,
        </p>
        <p className="font-serif-display text-3xl sm:text-4xl text-[#4A5346] mt-3">
          The family of {HONOREE}
        </p>
        <div className="mt-10 flex items-center justify-center gap-4 text-[#8FA092]">
          <span className="w-12 h-px bg-[#8FA092]/50" />
          <span className="font-serif-display italic">September 10 — 12, 2026</span>
          <span className="w-12 h-px bg-[#8FA092]/50" />
        </div>
        <p className="label-eyebrow mt-10 text-[#757E70]">
          Made with love · {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}
